import React from 'react'
import './bannerPreviews.css'

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M18 6L6 18M6 6l12 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

function PreviewLink({ linkUrl, linkLabel, className, inline = false }) {
  if (!linkUrl?.trim()) return null
  return (
    <>
      {inline ? ' ' : null}
      <a href={linkUrl} className={className} onClick={(event) => event.preventDefault()}>
        {linkLabel?.trim() || 'Ver más'}
      </a>
    </>
  )
}

/** Misma estructura que smart_front AppBanners.jsx — siempre estilo advertencia (ámbar) */
export function BannerBarPreview({ title, message, linkUrl, linkLabel }) {
  const displayTitle = title?.trim() || null
  const displayMessage = message?.trim() || 'Mensaje de ejemplo para el banner.'

  return (
    <div className="banner-preview-frame">
      <div className="app-banners__item app-banners__item--warning" role="status">
        <div className="app-banners__content">
          {displayTitle ? (
            <strong className="app-banners__title">{displayTitle}</strong>
          ) : null}
          {displayTitle && displayMessage ? (
            <span className="app-banners__separator" aria-hidden="true">—</span>
          ) : null}
          <span className="app-banners__message">
            {displayMessage}
            <PreviewLink linkUrl={linkUrl} linkLabel={linkLabel} className="app-banners__link" inline />
          </span>
        </div>
        <span className="app-banners__close" aria-hidden="true">
          <CloseIcon />
        </span>
      </div>
    </div>
  )
}

/** Mock inline del AnnouncementModal — solo el modal, sin overlay */
export function BannerModalPreview({ title, message, linkUrl, linkLabel }) {
  const displayTitle = title?.trim() || 'Comunicado SmartCFO'
  const displayMessage = message?.trim() || 'Mensaje de ejemplo para el modal.'

  return (
    <div className="banner-preview-frame">
      <div className="banner-preview-modal announcement-modal">
        <div className="banner-preview-modal__header">{displayTitle}</div>
        <div className="banner-preview-modal__content announcement-modal__content">
          <p className="announcement-modal__message">
            {displayMessage}
            <PreviewLink
              linkUrl={linkUrl}
              linkLabel={linkLabel}
              className="announcement-modal__link"
              inline
            />
          </p>
        </div>
        <div className="banner-preview-modal__actions">
          <span className="banner-preview-modal__btn">Cerrar</span>
        </div>
      </div>
    </div>
  )
}

export function ChannelPreview({ channel, title, message, linkUrl, linkLabel }) {
  if (channel === 'MODAL') {
    return (
      <BannerModalPreview
        title={title}
        message={message}
        linkUrl={linkUrl}
        linkLabel={linkLabel}
      />
    )
  }
  return (
    <BannerBarPreview
      title={title}
      message={message}
      linkUrl={linkUrl}
      linkLabel={linkLabel}
    />
  )
}
